export default __webpack_public_path__ + "static/media/DSC_0584.de6b36e3.webp";